import styled from 'styled-components';

export const BodyText = styled.p<{
  weight?: string;
  size?: 'small' | 'medium' | 'large';
  grey?: boolean;
  italics?: boolean;
  ltrDirection?: boolean;
  white?: boolean;
  nowrap?: boolean;
  margin?: string;
  overflowWrapBreak?: boolean;
  primary?: boolean;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.body.fontFamily};
  font-weight: ${(props) => (props.weight === 'light' ? '300' : '400')};
  font-weight: ${(props) => {
    switch (props.weight) {
      case 'light':
        return '300';
      case 'regular':
        return '400';
      case 'bold':
        return '500';
      default:
        return '400';
    }
  }};

  font-size: ${(props) => {
    switch (props.size) {
      case 'small':
        return '12px';
      case 'medium':
        return '13.5px';
      case 'large':
        return '15px';
      default:
        return '13.5px';
    }
  }};
  color: ${(props) =>
    props.primary
      ? props.theme.atlas.semantic.color.action.primary.default
      : props.grey
        ? props.theme.atlas.semantic.color.type.muted
        : props.white
          ? props.theme.atlas.semantic.color.type.inverse
          : props.theme.atlas.semantic.color.type.default};
  ${(props) => props.ltrDirection && 'direction: ltr;'}
  ${(props) => props.italics && 'font-style: italic;'}
  ${(props) => props.nowrap && 'white-space: nowrap;'}
  ${(props) => props.margin && `margin: ${props.margin}`};
  ${(props) => props.overflowWrapBreak && `overflow-wrap: break-word;`};
`;
